<app-landing-popup *ngIf="showPopup" (closePopup)="onClosePopup()"></app-landing-popup>

<!-- Section 1 -->
<div class="section-1">
    <div class="home-actions-container">
        <!-- Button -->
        <button class="login-button" (click)="navigateToEko()">
            {{'sec1_button_1' | translate}}
        </button>
        <button class="login-button" *ngIf="!loggedIn" (click)="openLoginDialog()">
            {{'gen_login' | translate}}
        </button>
    </div>
</div>